import { Link } from "react-router-dom"
import { ROOT } from "../../routes/routes_name"

const EducationSystemPage = () => {
    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between py-3">
                    <a href={ROOT} className="logo d-flex align-items-center me-auto me-xl-0">
                        <h1 className="sitename"><img src="../assets/img/ppg.png" alt="" srcSet="" /></h1>
                    </a>
                    <Link to={ROOT} className="btn-getstarted"><i className="bi bi-chevron-left"></i> Kembali</Link>
                </div>
            </header>
            <main className="main">
                <div className="page-title light-background">
                    <div className="container">
                        <h1>Sistem Pembelajaran</h1>
                        <nav className="breadcrumbs">
                            <ol>
                                <li><a href={ROOT}>Home</a></li>
                                <li className="current">Sistem Pembelajaran</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <section className="education-system section">
                    <div className="container">
                        <div className="text-center">
                            <img className="rounded-4 mb-4" style={{ width: "70%" }} src="/assets/img/ppg_daljab.jpeg" />
                        </div>
                        <div>
                            Secara umum, PPG Dalam Jabatan dilaksanakan mulai dari
                            pendalaman materi sampai Uji Kompetensi Mahasiswa PPG (UKMPPG),
                            dijelaskan sebagaimana berikut:
                        </div>
                        <div className="my-2">
                            <ol style={{ marginLeft: "-1em" }}>
                                <li>
                                    {/* <i className="bi bi-1-circle"></i> */}
                                    Kegiatan Pendalaman Materi. Kegiatan pendalaman materi
                                    dilakukan dalam bentuk:
                                    <ul style={{ marginLeft: "-2em" }}>
                                        <li><i className="bi bi-check"></i> Mengerjakan pretes modul;</li>
                                        <li><i className="bi bi-check"></i> Mempelajari materi yang disajikan dalam modul secara mandiri dan terstruktur;</li>
                                        <li><i className="bi bi-check"></i> Membuat ringkasan materi pada Modul Pedagogik dan profesional;</li>
                                        <li><i className="bi bi-check"></i> Mengerjakan tes formatif atau tugas-tugas terstruktur; dan</li>
                                        <li><i className="bi bi-check"></i> Mengerjakan tes akhir modul.</li>
                                    </ul>
                                </li>
                                <li>
                                    {/* <i className="bi bi-2-circle"></i> */}

                                    Pengembangan Perangkat Pembelajaran. Kegiatan Pengembangan
                                    Perangkat Pembelajaran dilaksanakan dalam rangka untuk
                                    menghasilkan produk sebagai berikut: Pertama, Perangkat
                                    Pembelajaran yang meliputi: analisis CP, penyusunan TP dan ATP,
                                    penyusunan materi ajar, penyusunan LKPD, alat peraga, media
                                    pembelajaran, penyusunan instrumen, dan penyusunan modul
                                    ajar; Kedua, Rekaman Video pembelajaran dari salah satu
                                    pertemuan dengan format data video MPEG berdurasi 7-10 menit.
                                </li>
                                <li>
                                    {/* <i className="bi bi-3-circle"></i> */}

                                    Induksi dan try out. Induksi dan try out dilaksanakan setelah selesai
                                    kegiatan pendalaman materi dan pengembangan perangkat
                                    pembelajaran. Induksi bertujuan untuk pendalaman materi yang
                                    relevan dengan kisi-kisi UKMPPG. Try out dilaksanakan dalam
                                    rangka uji coba pelaksanaan UKMPPG yang hasilnya dijadikan
                                    syarat untuk mengikuti UKMPPG.
                                </li>
                                <li>
                                    {/* <i className="bi bi-4-circle"></i> */}

                                    Uji Kompetensi Mahasiswa PPG. Uji Kompetensi Mahasiswa PPG
                                    (UKMPPG) merupakan bagian integral dari proses PPG Dalam
                                    Jabatan. Uji kompetensi PPG Dalam Jabatan terdiri atas:
                                    <ul style={{ marginLeft: "-2em" }}>
                                        <li><i className="bi bi-check"></i>
                                            Uji Kinerja, dilakukan dalam bentuk ujian praktik
                                            pembelajaran dan uji portofolio. Uji praktik pembelajaran
                                            meliputi uji persiapan pembelajaran dan pelaksanaan
                                            pembelajaran. Uji portofolio adalah uji yang terkait dengan
                                            dokumen portofolio yang disusun oleh mahasiswa PPG
                                            mencakup pengembangan diri, penelitian, refleksi diri,
                                            pencarian informasi, dan karya inovasi. Uji Kinerja dilakukan
                                            setelah mahasiswa PPG menyelesaikan seluruh proses
                                            pembelajaran; dan
                                        </li>
                                        <li><i className="bi bi-check"></i>
                                            Uji Pengetahuan, yakni uji tulis berbasis komputer berkaitan
                                            dengan penguasaan pengetahuan untuk memenuhi capaian
                                            pembelajaran program PPG.
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}
export default EducationSystemPage